import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { PageLayout } from 'client-portal/components/PageLayout'
import { UserCodeAvatar } from 'components/UserCodeAvatar'
import { Box } from 'components/Layout'

interface RouteParams {
  userId: string
}

export const UserBarcodeGenerator: React.VFC<RouteComponentProps<RouteParams>> = ({ match }) => (
  <PageLayout>
    <Box display="flex" justifyContent="center" alignItems="center" padding="0.25rem">
      <UserCodeAvatar isBarcode userId={match.params.userId} size="XL" />
    </Box>
  </PageLayout>
)
